import { FolioStatus } from "../models/billing/folio.model";
export var canFinalizeFolio = function (folio) {
    return folio.status === FolioStatus.DRAFT;
};
export var canMarkAsPaid = function (folio) {
    return folio.status === FolioStatus.OPEN || folio.status === FolioStatus.UNCOLLECTABLE;
};
export var canMarkAsUncollectable = function (folio) {
    return folio.status === FolioStatus.OPEN;
};
export var canVoidFolio = function (folio) {
    return folio.status === FolioStatus.OPEN;
};
export var canCapturePreauthorizedFolio = function (folio) {
    return folio.status === FolioStatus.PREAUTHORIZED;
};
export var canReleaseFunds = function (folio) {
    var _a;
    var provider = (_a = folio.provider) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    return folio.status === FolioStatus.PREAUTHORIZED &&
        (provider === 'stripe' || provider === 'hobex');
};
export var canRefund = function (folio) {
    var _a;
    var provider = (_a = folio.provider) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    return folio.status === FolioStatus.PAID &&
        (provider === 'stripe' || provider === 'hobex' || provider === 'fidelio');
};
export var canUpdateFolio = function (folio) {
    return folio.status === FolioStatus.DRAFT;
};
export var canDeleteFolio = function (folio) {
    return folio.status === FolioStatus.DRAFT;
};
export var canEditFolioItems = function (folio) {
    return folio.status === FolioStatus.DRAFT && !folio.externalInfo;
};
